/* @flow */

import * as React from 'react';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ElectroSelect from 'forms/components/inputs/ElectroSelect/ElectroSelect';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import styles from 'views/ActionDrawer/ActionDrawer.module.scss';
import type Form from 'forms/_.extend';

import AutoCompleteModel from 'models/forms/AutoCompleteModel.js';
import { autoCompleteCountries } from 'api/forms.js';

type TypeProps = {
  project: Object,
  form: Form,
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewSiteForm extends React.Component<*> {
  constructor(props: Object) {
    super(props);
    this.props.accountsModel.search = '';
    this.props.companyModel.search = '';
    this.props.companyModel.filterId = this.props.form.$('addSiteForm.tradingAccount').value;
  }

  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const form: Form = this.props.form;
    const { parentForm, fieldList }: Object = this.props;

    const countryModel: AutoCompleteModel = new AutoCompleteModel(autoCompleteCountries);

    if (fieldList.company) {
      countryModel.filterId = parentForm.$(`${fieldList.company}`).extra.selectID;
    }

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock divider={false} gutters={true}>
            <div className={styles['form-group']}>
              <ElectroTextField field={form.$('addSiteForm.companyName')} />
              <ElectroTextField field={form.$('addSiteForm.siteName')} />
              <ElectroTextField field={form.$('addSiteForm.streetNo')} />
              <ElectroTextField field={form.$('addSiteForm.townCity')} />
              <ElectroTextField field={form.$('addSiteForm.stateCountryProvince')} />
              <ElectroTextField field={form.$('addSiteForm.zipCode')} />
              <ElectroSelect
                field={form.$('addSiteForm.country')}
                model={countryModel}
                valueKey="id"
                simpleValue={true}
              />
              <ElectroTextField field={form.$('addSiteForm.contactPhoneNo')} />
              <ElectroTextField field={form.$('addSiteForm.contactFaxNo')} />
              <ElectroTextField field={form.$('addSiteForm.locationContact')} />
            </div>
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.create')} />
      </React.Fragment>
    );
  }
}
